import { Component,  Input } from '@angular/core';
import publicHelpers from 'globals/helpers/public-helpers';
import { Asset } from 'globals/store/assets.data';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'asset-card',
    template: `
<div class="person-card">
  <icon *ngIf="!!asset.icon" [i18]="true" [icon]="asset.icon"></icon>
  <div class="titles" *ngIf="{ link: !!tryToShowAsLink && !!asset.link && urlOk, name: asset.name || 'Unnamed asset' } as vars" [ngClass]="{ disabled: !!disabledMessage }">
    <a *ngIf="vars.link" [href]="asset.link" target="_blank" class="link" (click)="$event.stopPropagation()">
      <div class="file-name-url">{{ vars.name }} <icon [i12]="true" [icon]="'OPEN_IN_NEW12'"></icon></div>
    </a>
    <div class="asset-title" *ngIf="!vars.link">{{ vars.name }}</div>
    <div class="associated" *ngIf="!!disabledMessage">{{ disabledMessage }}</div>
  </div>
</div>
`,
    styleUrls: ['person-card.scss'],
    styles: [`
    .person-card { align-items: center }
    icon { margin-right: 5px; }
    .disabled { color: rgba(0, 0, 0, 0.4); }
    
  `],
    standalone: true,
    imports: [CommonModule, IconComponent],
})

export class AssetCardComponent {
  @Input() asset: Asset
  @Input() disabledMessage: string
  @Input() tryToShowAsLink: boolean
  urlOk = false


  ngOnChanges(changes) {
    if (changes.asset.currentValue) this.urlOk = publicHelpers.urlOk(changes.asset.currentValue.link)
  }

}
